"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Config = void 0;
require("reflect-metadata");
const typedi_1 = require("typedi");
let Config = class Config {
    constructor() {
        /**
         * @TODO add type for keys values
         */
        /**
         * Mapped object contains config values by keys
         * @private
         */
        this.env = new Map();
    }
    /**
     * Get config value by key
     *
     * @param key - key of requested value
     */
    get(key) {
        if (!this.env.has(key)) {
            throw new Error(`Value "${key}" is not defined.`);
        }
        return this.env.get(key);
    }
    /**
     * Add new value to the config
     *
     * @param key - key of a new value
     * @param value - the new value
     */
    set(key, value) {
        this.env.set(key, value);
    }
    /**
     * Removes value from config
     *
     * @param key - key of value to delete
     */
    delete(key) {
        this.env.delete(key);
    }
    /**
     * Returns a boolean indicating whether an element with the specified key exists or not
     *
     * @param key - key to check
     */
    has(key) {
        return this.env.has(key);
    }
};
exports.Config = Config;
/**
 * Name of exported module property
 */
Config.exportName = 'config';
exports.Config = Config = __decorate([
    (0, typedi_1.Service)()
], Config);
